<template>
  <div class="MyCenter">
    <van-nav-bar
      fixed
      title="载体展示"
      left-arrow
      @click-left="$router.go(-1)"
    ></van-nav-bar>
    <Jlmap></Jlmap>
  </div>
</template>
<script>
import Jlmap from "@/components/Jlmap";
export default {
  name: "MyCenter",
  components: {
    Jlmap,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style type="text/css" scoped>
.MyCenter {
  position: fixed;
  top:30px;
  bottom: 50px;
  width: 100%;
  overflow: hidden;
  z-index: 1;
  background-color: rgb(247, 248, 250) !important;
}


.cellView {
  margin: 10px auto;
  width: 95%;
}

.profile-userpic {
  text-align: center;
}

.profile-userpic img {
  float: none;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  -webkit-border-radius: 50% !important;
  -moz-border-radius: 50% !important;
  border-radius: 50% !important;
}

.profile-usertitle-bg {
  background: url("../../assets/imgs/02f5521270e421a141675e168a78fd0.png")
    no-repeat;
  background-size: cover;
}

.profile-usertitle-name {
  font-size: 25px;
  color: #fff;
}

.profile-usertitle-job {
  font-size: 15px;
  color: #fff;
}
</style>
